module.exports = "<div class=c-activity__add> <button type=button class=\"c-button c-button--icon\" ng-click=$ctrl.addToBasket() ng-disabled=$ctrl.isDisabled() ng-class=\"{\n            'c-button--loading': $ctrl.basket.saving\n        }\"> <span class=c-button__text>Add to Basket</span> <span class=c-button__icon> <span class=c-button__loading ng-if=$ctrl.basket.saving> <spinner></spinner> </span> </span> </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/activity.add.html
// module id = 798
// module chunks = 0